<template>
  <div>
    <transition name="fade">
      <div v-if="contactus">
        <p class="text-6xl font-bold text-red-500 p1">{{ $t("ContactUs") }}</p>
      </div>
    </transition>

    <transition name="fade">
      <div class="p-4" v-if="headoffice">
        <p class="text-4xl p2">{{ $t("HeadOffice") }}</p>
        <p class="text-2xl p2">
          <v-icon name="home"></v-icon>4th Floor, Vibulthani 1 Tower,3195/9 Rama IV Rd.,
          Klongton, Klongtoey, Bangkok
        </p>
      </div>
    </transition>

    <transition name="fade">
      <div class="p-4" v-if="branchoffice">
        <p class="text-4xl p2">{{ $t("BranchOffice") }}</p>
        <p class="text-2xl p2">
          <v-icon name="home"></v-icon>Laem Chabang Office: 88/34 Moo 9, Sukhumvit Rd., T. Tungsukha, A.Sriracha, Chonburi 20230
        </p>
      </div>
    </transition>

    <transition name="fade">
      <div class="p-6" v-if="ch">
        <p class="text-4xl p2">
          <v-icon name="user"></v-icon>Mr. Chaiya Punkeaw – Managing Director
        </p>
        <p class="text-2xl p2">
          <v-icon name="mail"></v-icon>Email :
          <a
            href="mailto:chaiya.p@wearelogistics.co.th"
            target="_top"
          >chaiya.p@wearelogistics.co.th</a>
        </p>
        <p class="text-2xl p2">
          <v-icon name="phone"></v-icon>Tel: +662-0662807
        </p>
        <p class="text-2xl p2">
          <v-icon name="smartphone"></v-icon>Mobile: +6680-9725551
        </p>
        <p class="text-2xl p2">
          <v-icon name="facebook"></v-icon>FB :<a
            href="https://www.facebook.com/chaiya.punkeaw.3"
            target="_top"
          > Chaiya Punkeaw</a>
        </p>
        <p class="text-2xl p2">
          <v-icon name="facebook"></v-icon>FB Page :<a
            href="https://www.facebook.com/chaiya.punkeaw.3"
            target="_top"
          > WE Are Logistics 1998</a>
        </p>
      </div>
    </transition>

    <transition name="fade">
      <div class="p-6" v-if="sk">
        <p class="text-4xl p2">
          <v-icon name="user"></v-icon>Mr. Sukij Hahingsa – Sales Director
        </p>
        <p class="text-2xl p2">
          <v-icon name="mail"></v-icon>Email :
          <a
            href="mailto:sukij.h@wearelogistics.co.th"
            target="_top"
          >sukij.h@wearelogistics.co.th</a>
        </p>
        <p class="text-2xl p2">
          <v-icon name="phone"></v-icon>Tel: +662-0662807
        </p>
        <p class="text-2xl p2">
          <v-icon name="smartphone"></v-icon>Mobile: +6681-6228859
        </p>
        <p class="text-2xl p2">
          <v-icon name="link"></v-icon>Line ID : 0816228859
        </p>
        <p class="text-2xl p2">
          <v-icon name="link"></v-icon>WeChat ID : Sukij_66816228859
        </p>
      </div>
    </transition>

    <transition name="fade">
      <div class="p-6" v-if="pt">
        <p class="text-4xl p2">
          <v-icon name="user"></v-icon>Ms. Pathumrat Sanghiran -Financial Director
        </p>
        <p class="text-2xl p2">
          <v-icon name="mail"></v-icon>Email :
          <a
            href="mailto:pathumrat.s@wearelogistics.co.th "
            target="_top"
          >pathumrat.s@wearelogistics.co.th</a>
        </p>
        <p class="text-2xl p2">
          <v-icon name="phone"></v-icon>Tel: +662-0571913 #102
        </p>
        <p class="text-2xl p2">
          <v-icon name="smartphone"></v-icon>Mobile: +6681-8386582
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toptext: "This is Top Text",
      contactus: false,
      headoffice: false,
      branchoffice: false,
      ch: false,
      sk: false,
      pt: false
    };
  },
  created() {
    setTimeout(() => {
      this.contactus = true;
    }, 500);
    setTimeout(() => {
      this.headoffice = true;
    }, 2000);
    setTimeout(() => {
      this.branchoffice = true;
    }, 3000);
    setTimeout(() => {
      this.ch = true;
    }, 4000);
    setTimeout(() => {
      this.sk = true;
    }, 6000);
    setTimeout(() => {
      this.pt = true;
    }, 7000);
  }
};
</script>

<style lang="stylus" scoped>
.p1 {
  color: red;
}

.p2 {
  color: black;
}

.icon {
  width: 24px;
}

.icon:hover {
  color: rgb(219, 53, 53);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 2s;
}
</style>